import { render, staticRenderFns } from "./exchangerate.vue?vue&type=template&id=dcddf16c&scoped=true"
import script from "./exchangerate.vue?vue&type=script&lang=js"
export * from "./exchangerate.vue?vue&type=script&lang=js"
import style0 from "./exchangerate.vue?vue&type=style&index=0&id=dcddf16c&prod&lang=css"
import style1 from "./exchangerate.vue?vue&type=style&index=1&id=dcddf16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcddf16c",
  null
  
)

export default component.exports